import { render, staticRenderFns } from "./CustomizeMetalAJ.vue?vue&type=template&id=b44a4376&scoped=true"
import script from "./CustomizeMetalAJ.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalAJ.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalAJ.vue?vue&type=style&index=0&id=b44a4376&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44a4376",
  null
  
)

export default component.exports